import { render } from "./DocConformity.vue?vue&type=template&id=32dab89a"
import script from "./DocConformity.vue?vue&type=script&lang=js"
export * from "./DocConformity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__